import { gql } from '@apollo/client';

export const GENERATE_COOPERATION_WAREHOUSE_BLACKLIST_DOWNLOAD_REPORT = gql`
  mutation GenerateCooperationWarehouseBlacklistDownloadReport($filters: CooperationWarehouseFiltersTypeInput, $timezone: String) {
    generateCooperationWarehouseBlacklistDownloadReport(filters: $filters, timezone: $timezone)
  }
`;

export const SAVE_COOPERATION_WAREHOUSE = gql`
  mutation SaveCooperationWarehouse($input: SaveCooperationWarehouseInput!) {
    saveCooperationWarehouse(input: $input) {
      result
      message
      originalRequest {
        id
        name
        type
        warehouseId
        status
        addressLine1
        addressLine2
        country
        state
        city
        zipcode
        addressHash
        latitude
        longitude
        contactPersonList {
          name
          phone
          countryCode
          extension
        }
        email
        warehouseName
        workWeekdayList
        workStartTime
        workEndTime
        expectedPickupStartTime
        expectedPickupEndTime
        aliasList
        relatedAddressList {
          address1
          address2
        }
        isNew
        continuousFailure
        standingPickup
        channelId
        relatedChannelIds
        vehicleTypeId
      }
      existingOrSimilar {
        id
        name
        type
        warehouseId
        status
        addressLine1
        addressLine2
        country
        state
        city
        zipcode
        addressHash
        latitude
        longitude
        contactPersonList {
          name
          phone
          countryCode
          extension
        }
        email
        warehouseName
        workWeekdayList
        workStartTime
        workEndTime
        expectedPickupStartTime
        expectedPickupEndTime
        aliasList
        relatedAddressList {
          address1
          address2
        }
        isNew
        continuousFailure
        standingPickup
        channelId
        relatedChannelIds
        vehicleTypeId
      }
      submitCount
    }
  }
`;

